module.exports = __webpack_public_path__ + "fonts/Rubik-500-latin-ext23.15c3dca.woff2";